import { render, staticRenderFns } from "./VStaffTable.vue?vue&type=template&id=7e05318b&"
import script from "./VStaffTable.vue?vue&type=script&lang=ts&"
export * from "./VStaffTable.vue?vue&type=script&lang=ts&"
import style0 from "./VStaffTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports